<ion-card class="textCenter" [ngStyle]="{background: feed.json_details.gender == 'MALE' ? '#B6E4F4' : '#F5D5C6'}">
  <div style="background-image: url('../../../../assets/imgs/txtr.png');">
    <div class="headerTitle">शोक सन्देश</div>
    <ion-row>
      <ion-col size="3" class="align-bottom" style="padding-bottom: 10px;">
        <img src="../../../../assets/imgs/cagbti.png">
      </ion-col>
      <ion-col size="6" class="padding15">
        <img [src]="feed.image_urls[0]" *ngIf="feed.image_urls && feed.image_urls.length > 0" class="card-image">
        <img src="../../../../assets/imgs/feed_shok.jpeg" *ngIf="!feed.image_urls || feed.image_urls.length == 0"
          class="card-image">
      </ion-col>
      <ion-col size="3" class="align-bottom" style="padding-bottom: 20px;">
        <img src="../../../../assets/imgs/cfulbti.png">
      </ion-col>
    </ion-row>

    <div class="detailsSection">
      हम अत्यंत दुख के साथ सूचित करते हैं कि प्रिय
      <h5 class="nameTitle" (click)="feedService.openDetails(feed.id)">Late {{feed.header}} Ji</h5>
      <p class="subTitle">{{feed.description}}</p>
      <p class="margin5px">का देहावसान दिनांक <b class="font1_1">{{feed.event_date | fancyDateOnly}}</b>
        को हो गया। ईश्वर दिवंगत आत्मा को अपने श्रीचरणों में स्थान दें और शोकाकुल परिवार को इस अपार दुख को सहने की शक्ति
        प्रदान करें।

        <!-- हम सभी दिवंगत आत्मा की असीम शांति हेतु परमेश्वर से प्रार्थना करते हैं। -->
      </p>
    </div>
    <div class="familySection">
      <h3 class="sectionTitle">शोकाकुल परिवार</h3>
      {{feed.json_details.family_members}}
    </div>
    <a class="textLeft" *ngIf="feed.json_details.contact_number || feed.json_details.contact"
      [href]="'tel:'+feed.json_details.contact_number">
      <ion-row>
        <ion-col size="1">
          <ion-icon color="tertiary" name="call-outline"></ion-icon>
        </ion-col>
        <ion-col size="11">
          <div style="width: 100%; overflow-x: auto; white-space: nowrap;">
            <b>{{feed.json_details.contact}}</b>,{{feed.json_details.contact_number}}
          </div>
        </ion-col>
      </ion-row>
    </a>

    <div class="dateSection textLeft">
      <h3 class="sectionTitle">संस्कार तिथियाँ / उत्तरक्रिया कार्यक्रम</h3>
      <div *ngIf="feed.event_date">
        निधन तिथि: <span class="floatRight">{{feed.event_date | fancyDate}}</span>
      </div>
      <div *ngIf="feed.json_details.carnation_date">
        मुख अग्नि: <span class="floatRight">{{feed.json_details.carnation_date | fancyDate}}</span>
      </div>
      <div *ngIf="feed.json_details.pushpanjali">
        उठावना / पुष्पांजलि: <span class="floatRight">{{feed.json_details.pushpanjali | fancyDate}}</span>
      </div>
      <div *ngIf="feed.json_details.ganga_prashadi">
        गंगा प्रसादी: <span class="floatRight">{{feed.json_details.ganga_prashadi | fancyDate}}</span>
      </div>
    </div>
  </div>
  <ion-row *ngIf="details && feed.creator" class="textLeft">
    <ion-col size="1.5">
      <span *ngIf="feed.creator">
        <img width="30px" height="30px" [src]="feed.creator.url" *ngIf="feed.creator && feed.creator.url"
          class="circular">
        <ion-icon name="person-circle-outline" *ngIf="!feed.creator.url" class="font3" color="light"></ion-icon>
      </span>
    </ion-col>
    <ion-col size="9.5">
      <div *ngIf="feed.creator">{{feed.creator.name}}</div>
      <div class="font0_8">{{feed.created_at | fancyDate}}</div>
    </ion-col>
    <ion-col size="1">
      <ion-icon name="logo-whatsapp" (click)="feedService.share(feed)"></ion-icon>
    </ion-col>
  </ion-row>
</ion-card>